import { AppointmentDetailDialog } from "@/domains/appointment/appointments/components/appointment-detail-dialog/appointment-detail-dialog";
import { PageContent } from "@/lib/components/page-content";
import { useDialogRouterSimple } from "@/lib/dialog/use-dialog-router-simple";
import { NotificationListHeader } from "../components/header/notification-list-header";
import { NotificationList } from "../components/lists";

export function NotificationsPage() {
  const { isDialogOpen, getDialogConfig, closeDialog, openDialog } = useDialogRouterSimple();

  // Get appointment dialog state
  const appointmentDialogOpen = isDialogOpen("appointment-detail");
  const appointmentDialogConfig = getDialogConfig("appointment-detail");
  const appointmentId = appointmentDialogConfig?.id || null;

  const handleOpenDialog = (type: string, id: string, params?: Record<string, any>) => {
    openDialog({ type: type as any, id, params });
  };

  return (
    <>
      <NotificationListHeader />

      <PageContent padding="md:px-3">
        <NotificationList onOpenDialog={handleOpenDialog} />
      </PageContent>

      {/* Appointment Detail Dialog */}
      <AppointmentDetailDialog
        appointmentId={appointmentId}
        open={appointmentDialogOpen}
        onClose={() => closeDialog("appointment-detail")}
      />
    </>
  );
}
